import { render, staticRenderFns } from "./AccountDetailPage.vue?vue&type=template&id=471519f6&lang=pug&"
import script from "./AccountDetailPage.vue?vue&type=script&lang=js&"
export * from "./AccountDetailPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports